import { useContext, useEffect, useRef, useState } from 'react';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import MenuHolidayEdit from './MenuHolidayEdit';
import { SocketContext } from '../../../App';
import dayjs from 'dayjs';
import { Select, Space } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import system from "../../../config/systematic";
import getList from '../../universal/getList';

export default function MenuHoliday(props: any) {

    const ref = useRef<any>(undefined);
    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;

    /**地区数据 */
    const [areaData, setAreaData] = useState<any>();

    const [yearData, setYearData] = useState<any>();

    const [areaIdData, setAreaIdData] = useState<any>();
    const [yearIdData, setYearIdData] = useState<any>();

    /** 后端数据Service */
    let wmService = system.wmService;

    /** api服务id */
    const apiId = 'menuHoliday';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }

        //同步获取数据 async - await
        const fetchData = async () => {
            let yearArray = [];
            for (var i = 2026; i < 2050; i++) {
                yearArray.push({ value: i, label: i })
            }
            setYearData(yearArray);

            fetchApi.GET(wmService, {
                apiId: "area",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setAreaData(res.data);
                }
            });
        }
        
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    //查看不同年份/不同区域的内容
    const selectChange = (e: any, key: any, setData: any, setOtherData?: any) => {
        setData(e);
        if (setOtherData) {
            setOtherData(e);
        }
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                year: key === 'year' ? e : yearIdData,
                areaId: key === 'area' ? e : areaIdData,
            }
        }
        ref.current.initData(currentData);
    }

    //表头
    const columnsHead = [
        {
            title: '区域',
            dataIndex: 'areaId',
            render: (text: any, record: any) => {
                return (
                    <div>{record.areaName}</div>
                )
            }
        },
        {
            title: '节假日名称',
            dataIndex: 'menuHolidayName',
        },
        {
            title: '年份',
            dataIndex: 'year',
        },
        {
            title: '开始时间',
            dataIndex: 'startTime',
            render: (text: any, record: any) => {
                return (
                    <div>{dayjs(record.startTime).format("YYYY-MM-DD")}</div>
                )
            }
        },
        {
            title: '结束时间',
            dataIndex: 'endTime',
            render: (text: any, record: any) => {
                return (
                    <div>{dayjs(record.endTime).format("YYYY-MM-DD")}</div>
                )
            }
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '节假日',
        apiId,
        columns,
        showStates: true,
        showQuery: true,
        pagination: true,
        showDelete: true,
        showAdd: true,
        EditComponent: MenuHolidayEdit,
    };

    return (
        <>
            <Space>
                <Select
                    showSearch
                    allowClear
                    onChange={(e) => selectChange(e, "area", setAreaIdData)}
                    onClear={() => selectChange(undefined, "area", setAreaIdData)}
                    placeholder="区域"
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {getList.generalEx(areaData, {
                        itemName: "areaName",
                        includeNull: false
                    })}
                </Select>

                <Select
                    showSearch
                    allowClear
                    onChange={(e) => selectChange(e, "year", setYearIdData)}
                    onClear={() => selectChange(undefined, "year", setYearIdData)}
                    style={{ width: '80px' }}
                    options={yearData}>
                </Select>
            </Space>

            <span>&nbsp;&nbsp;</span>
            <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>
        </>
    )
}